import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { NotificationItem } from '@data/schema/notificationitem';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly notificationSubject = new Subject<NotificationItem>();
  private readonly clearStack = new Subject<boolean>();
  private readonly notificationDuration = 5000;

  constructor(private snackBar: MatSnackBar) {}
  /**
   * @returns notification observable.
   */
  public getNotificationObs(): Observable<any> {
    return this.notificationSubject.asObservable();
  }

  /**
   * This method can be called to show notifications by passing message and type.
   * @param message accepts notification message and type.
   */
  showNotification(message: NotificationItem) {
    if (message?.message?.trim() !== '') {
      this.notificationSubject.next(message);
      return true;
    }
    return false;
  }

  public flushNotificationObs() {
    return this.clearStack.asObservable();
  }

  flushNotifications() {
    this.clearStack.next(true);
  }

  /**
   * This method can be called to show snackbar by passing message and type.
   * @param message accepts notification message.
   * @param type accepts notification type. (success, error)
   */
  showSnackBar(message: string, type: string = 'success') {
    this.snackBar.open(message, 'Okay', {
      duration: this.notificationDuration,
      panelClass: `gah-snackbar__${type}`,
    });
  }

  showSnackBarWithPosition(message: string, type: string = 'success', 
    verticalPosition: any, horizontalPosition: any) {
    this.snackBar.open(message, 'Okay', {
      duration: this.notificationDuration,
      verticalPosition: verticalPosition,
      horizontalPosition: horizontalPosition,
      panelClass: `gah-snackbar__${type}`,
    });
  }
}
